import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Button from "../../component/ui/Button";

// 1. Swiper Imports
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

// 2. Swiper CSS
import "swiper/css";
import "swiper/css/pagination";

// GSAP Plugins Register
gsap.registerPlugin(ScrollTrigger);

const Clients = () => {
  const sectionRef = useRef(null);
  const [playingId, setPlayingId] = useState(null); // Tracks which video is playing
  useEffect(() => {
    // 3. Animation logic remains the same
    const context = gsap.context(() => {
      // Collect all HEADING and PARAGRAPH text elements in the header area
      const textElements = gsap.utils.toArray(
        sectionRef.current.querySelectorAll(".news-header-text")
      );

      // --- 1. Scrubbed Text Reveal Animation (Header) ---
      textElements.forEach((element, index) => {
        gsap.set(element, {
          y: 25,
          opacity: 0,
          clipPath: "inset(100% 0 0% 0)",
        });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: sectionRef.current.querySelector(".news-header-container"),
            start: "top 85%",
            end: "center 60%",
            scrub: 1,
          },
        });

        tl.to(element, {
          y: 0,
          opacity: 1,
          clipPath: "inset(0% 0 0% 0)",
          duration: 1,
          ease: "power2.out",
          delay: index * 0.1,
        });
      });

      // --- 2. Scrubbed Divider Line Animation (Grow from Left) ---
      const lineElement =
        sectionRef.current.querySelector(".news-divider-line");
      if (lineElement) {
        gsap.set(lineElement, { scaleX: 0, transformOrigin: "left" });

        gsap.to(lineElement, {
          scaleX: 1,
          duration: 1,
          ease: "none",
          scrollTrigger: {
            trigger: lineElement.closest(".news-subtitle-container"),
            start: "top 85%",
            end: "center 60%",
            scrub: 1,
          },
        });
      }
    }, sectionRef);

    return () => context.revert();
  }, []);

  const newsArticles = [
    {
      id: 1,
      title: "Modi Sir",
      description: "Environment Days",
      image: "/images/Clients/Clients1.webp",
      link: "https://www.gailonline.com/cbgCgd.html",
    },
    // {
    //   id: 2,
    //   title: "Public Meeting",
    //   description: "Kheda, Gujarat",
    //   image: "/images/Clients/Clients2.webp",
    // },
    {
      id: 2,
      title: "PM - Narendra Modi",
      description: "Addresses Bio-gas Plant",
      image: "/images/Clients/Clients5.webp",
      link: "https://realbites.com/",
    },
    {
      id: 3,
      title: "PM - Narendra Modi",
      description: "Addresses Bio-gas Plant",
      image: "/images/Clients/Clients3.webp",
      link: "https://www.gujaratgas.com/",
    },
    {
      id: 4,
      title: "PM - Narendra Modi",
      description: "Addresses Bio-gas Plant",
      image: "/images/Clients/Clients4.webp",
      link: "https://jkmalt.com/",
    },
  ];

  return (
    <>
      {/* 5. Inject CSS to hide Swiper Pagination */}
      <style global jsx>{`
        /* Target the main Swiper pagination container */
        .swiper-pagination {
          display: none !important;
        }
      `}</style>

      <section
        ref={sectionRef}
        className="w-auto bg-[#F2F6EC] py-[27px] sm:py-[40px] 2xl:py-[54px] "
      >
        {/* Section Header (Unchanged) */}
        <div className="flex flex-col gap-[11px] sm:gap-[16px] 2xl:gap-[22px] justify-start items-start w-auto h-auto mt-[23px] sm:mt-[34px] 2xl:mt-[46px] mr-[32px] md:mr-[112px] 2xl:mr-[150px] ml-[32px] md:ml-[112px] 2xl:ml-[150px] news-header-container">
          {/* Subtitle and Line */}
          <div className="flex flex-row justify-start items-center w-full news-subtitle-container overflow-hidden">
            <div className="overflow-hidden">
              <p className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-[#1c233a] font-[Sora] news-header-text">
                Our
              </p>
            </div>
            <div className="w-[100px] sm:w-[150px] 2xl:w-[200px] h-[1px] bg-[#1c233a]  ml-[15px] news-divider-line"></div>
          </div>

          {/* Title */}
          <div className="overflow-hidden">
            <h2 className="text-[30px] sm:text-[45px] 2xl:text-[60px] font-bold leading-[38px] sm:leading-[57px] 2xl:leading-[76px] text-left text-[#1c233a] font-[Sora] news-header-text">
              Clients
            </h2>
          </div>

          {/* Paragraph */}
          <div className="overflow-hidden">
            <p className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[24px] sm:leading-[30px] 2xl:leading-[38px] text-left text-[#1c233a] font-[Sora]  news-header-text">
              Our clients include energy companies, industries, and raw material
              suppliers—farmers, agro-industries, and waste
              generators—supporting large-scale CBG production.
            </p>
          </div>
        </div>

        {/* Swiper Slider Implementation */}
        {/* Note: Swiper adds its own wrappers, so the outer div margin is kept */}
        <div className="flex gap-[10px] items-center justify-center lg:justify-start flex-wrap md:gap-[28px] mt-[30px] sm:mt-[45px] 2xl:mt-[60px] overflow-hidden max-w-[1620px] m-auto px-[30px]  ">
          {newsArticles?.map((article) => (
            <div className="flex flex-col group">
              {/* MEDIA CONTAINER */}
              <div className="relative  ">
                <div className="relative cursor-pointer overflow-hidden w-[250px]  h-[107px] rounded-[15px] sm:rounded-[22px] 2xl:rounded-[30px] bg-white flex items-center justify-center px-[10px] sm:px-[15px] 2xl:px-[20px] py-[10px] ">
                  <img
                    src={article?.image}
                    alt={article?.title}
                    className=" rounded-[15px] sm:rounded-[22px] 2xl:rounded-[30px] h-full"
                    onClick={() =>
                      window.open(article.link, "_blank", "noopener,noreferrer")
                    }
                  />
                </div>
              </div>

              {/* TEXT CONTENT */}
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Clients;
